<td nzAlign="center">
  <app-lot-mini-gallery [lot]="bid?.lot"></app-lot-mini-gallery>
</td>

<td nzAlign="center">
  {{ bid?.lot?.auctionName }}<br />
  {{ bid?.lot?.auctionDatetime | date: 'yyyy-MM-dd HH:mm:ss zz':'+0900' }}<br />
  <a
    nzSize="small"
    class="lot-button"
    nz-button
    nzType="primary"
    href="javascript:void(0)"
  >
    {{ bid?.lot?.code }}
  </a>
</td>

<td nzAlign="center">
  <app-lot-bid-amount [bid]="bid"></app-lot-bid-amount>
  <app-bid-leader-status [lot]="bid?.lot" [bid]="bid"></app-bid-leader-status>
  <div *ngIf="bid?.lot?.soldPrice">
    {{ bid?.lot?.soldPrice | currency:'JPY':'symbol-narrow' }}
  </div>
</td>

<td nzAlign="center" [ngClass]="'hide-column-small hide-column-medium'">
  <ng-container *ngIf="bid?.bidGroup">
    <div>{{ bid?.bidGroup?.letter }}-{{ bid?.bidGroup?.quantity }}</div>
    <div>{{ bid?.bidGroup?.date | date: 'dd.MM' }}</div>
  </ng-container>
</td>

<td nzAlign="left" class="hide-column-small">
  {{ bid?.lot?.title }}
</td>

<td nzAlign="left" class="hide-column-small">
  <div class="lot-data">
    <p *ngIf="bid?.lot?.modelTypeEn">
      <strong>{{ 'LOT_INFO.CHASSIS_ID' | translate }}:</strong>
      {{ bid?.lot?.modelTypeEn }}
    </p>
    <p *ngIf="bid?.lot?.engineVolumeNum">
      <strong>{{ 'LOT_INFO.ENGINE_CC' | translate }}:</strong>
      {{ bid?.lot?.engineVolumeNum }}
    </p>
    <p *ngIf="bid?.lot?.mileageNum">
      <strong>{{ 'LOT_INFO.MILEAGE' | translate }}:</strong>
      {{ bid?.lot?.mileageNum }}
    </p>
  </div>
</td>

<td nzAlign="center" class="hide-column-small">
  <nz-tag>
    {{ bid?.status | uppercase | translate }}
  </nz-tag>
</td>

<td nzAlign="center" class="hide-column-small" style="color: #378de5">
  {{ bid?.bidCondition?.title | translate }}
</td>

<td nzAlign="center" class="hide-column-small">
  {{ bid?.createdAt | date: 'yyyy-MM-dd HH:mm:ss zz':'+0900' }}
</td>

<td nzAlign="center">
  <nz-row [nzGutter]="[5, 5]">
    <nz-col>
      <button
        class="bid-place-comment-btn"
        nz-button
        nzType="primary"
        type="button"
        appGuideAnchor="comment-button"
      >
        <i nz-icon nzType="comment" nzTheme="outline"></i>
      </button>
    </nz-col>

    <nz-col>
      <button
        class="bid-place-delete-btn"
        nz-button
        nzType="primary"
        nzDanger
        type="button"
        appGuideAnchor="delete-button"
      >
        <i nz-icon nzType="delete" nzTheme="outline"></i>
      </button>
    </nz-col>
  </nz-row>
</td>
